import { render, staticRenderFns } from "./shopDiscuss.vue?vue&type=template&id=6a361847&"
import script from "./shopDiscuss.vue?vue&type=script&lang=ts&"
export * from "./shopDiscuss.vue?vue&type=script&lang=ts&"
import style0 from "./shopDiscuss.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports